<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="formData" label-width="120px">
      <el-form-item prop="projectName" label="项目名称">
        <el-input v-model="formData.projectName"></el-input>
      </el-form-item>
      <el-form-item prop="projectType" label="项目性质">
        <el-input v-model="formData.projectType"></el-input>
      </el-form-item>
      <el-form-item prop="progressStatus" label="项目进度">
        <el-input v-model="formData.progressStatus"></el-input>
      </el-form-item>
      <el-form-item prop="projectDescription" label="项目简介">
        <el-input v-model="formData.projectDescription"></el-input>
      </el-form-item>
      <el-form-item prop="ownerUnit" label="业主单位">
        <el-input v-model="formData.ownerUnit"></el-input>
      </el-form-item>
      <el-form-item prop="incomeContractNo" label="收入合同号">
        <el-input v-model="formData.incomeContractNo"></el-input>
      </el-form-item>
      <el-form-item prop="incomeContractSigned" label="合同签订主体">
        <el-input v-model="formData.incomeContractSigned"></el-input>
      </el-form-item>

      <el-form-item prop="incomeContractSignedDate" label="签订时间">
        <el-date-picker
          v-model="formData.incomeContractSignedDate"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>

      <el-form-item prop="incomeContractTotal" label="合同金额合计">
        <el-input v-model="formData.incomeContractTotal"></el-input>
      </el-form-item>

      <el-form-item prop="incomeContactPerson" label="联系人">
        <el-input v-model="formData.incomeContactPerson"></el-input>
      </el-form-item>

      <el-form-item prop="incomeContactPhone" label="联系方式">
        <el-input v-model="formData.incomeContactPhone"></el-input>
      </el-form-item>

      <el-form-item prop="incomeDevice" label="设备收入">
        <el-input v-model="formData.incomeDevice"></el-input>
      </el-form-item>

      <el-form-item prop="incomeService" label="服务收入">
        <el-input v-model="formData.incomeService"></el-input>
      </el-form-item>

      <el-form-item prop="incomeConstruction" label="施工收入">
        <el-input v-model="formData.incomeConstruction"></el-input>
      </el-form-item>

      <el-form-item prop="incomeCt" label="CT收入">
        <el-input v-model="formData.incomeCt"></el-input>
      </el-form-item>

      <el-form-item prop="incomeContractLimit" label="合同期限">
        <el-input v-model="formData.incomeContractLimit"></el-input>
      </el-form-item>

      <el-form-item prop="incomeAcceptanceDate" label="验收时间">
        <el-date-picker
          v-model="formData.incomeAcceptanceDate"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>

      <el-form-item prop="incomePaymentInfo" label="付款信息">
        <el-input v-model="formData.incomePaymentInfo"></el-input>
      </el-form-item>

      <el-form-item prop="warrantyRecoverDate" label="质保金回收时间">
        <el-date-picker
          v-model="formData.warrantyRecoverDate"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>

      <el-form-item prop="integrators" label="集成商">
        <el-input v-model="formData.integrators"></el-input>
      </el-form-item>

      <el-form-item prop="disburseContractNo" label="支出合同号">
        <el-input v-model="formData.disburseContractNo"></el-input>
      </el-form-item>

      <el-form-item prop="disburseContractSignedDate" label="签订时间">
        <el-date-picker
          v-model="formData.disburseContractSignedDate"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>

      <el-form-item prop="disburseContractTotal" label="支出金额合计">
        <el-input v-model="formData.disburseContractTotal"></el-input>
      </el-form-item>

      <el-form-item prop="disburseDevice" label="设备支出">
        <el-input v-model="formData.disburseDevice"></el-input>
      </el-form-item>

      <el-form-item prop="disburseService" label="服务支出">
        <el-input v-model="formData.disburseService"></el-input>
      </el-form-item>

      <el-form-item prop="disburseConstruction" label="施工支出">
        <el-input v-model="formData.disburseConstruction"></el-input>
      </el-form-item>

      <el-form-item prop="disburseContactPerson" label="联系人">
        <el-input v-model="formData.disburseContactPerson"></el-input>
      </el-form-item>
      <el-form-item prop="disburseContactPhone" label="联系方式">
        <el-input v-model="formData.disburseContactPhone"></el-input>
      </el-form-item>
      <el-form-item prop="disbursePaymentInfo" label="支出款信息">
        <el-input v-model="formData.disbursePaymentInfo"></el-input>
      </el-form-item>

      <el-form-item prop="accrualInfo" label="计收信息">
        <el-input v-model="formData.accrualInfo"></el-input>
      </el-form-item>

      <el-form-item prop="surplusAccrualAmount" label="剩余计收金额">
        <el-input v-model="formData.surplusAccrualAmount"></el-input>
      </el-form-item>

      <el-form-item prop="projectManagerA" label="项目经理A">
        <el-input v-model="formData.projectManagerA"></el-input>
      </el-form-item>
      <el-form-item prop="onSaleManager" label="售中经理">
        <el-input v-model="formData.onSaleManager"></el-input>
      </el-form-item>

      <el-form-item prop="afterSaleManager" label="售后经理">
        <el-input v-model="formData.afterSaleManager"></el-input>
      </el-form-item>

      <el-form-item prop="businessName" label="业务区">
        <el-input v-model="formData.businessName"></el-input>
      </el-form-item>

      <el-form-item prop="clientManager" label="客户经理">
        <el-input v-model="formData.clientManager"></el-input>
      </el-form-item>

      <el-form-item prop="returnVisitCycle" label="回访周期">
        <el-input v-model="formData.returnVisitCycle"></el-input>
      </el-form-item>
      <el-form-item prop="returnVisitPlan" label="回访计划">
        <el-date-picker
          v-model="formData.returnVisitPlan"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item prop="returnVisitResult" label="售后回访结果">
        <el-input v-model="formData.returnVisitResult"></el-input>
      </el-form-item>
    </el-form>
    <div class="foot">
      <el-button @click="goback">返 回</el-button>
      <el-button v-if="handleType === 'add'" type="primary" @click="handleAdd">确 定 新 增</el-button>
      <el-button v-else type="primary" @click="handleEdit">确 定</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "detail",

  data() {
    return {
      formData: {},
      handleType: "",
    };
  },
  created() {
    let routeId = this.$route.query.id;
    if (routeId !== 0) {
      this.handleType = "edit";
      this.form = this.getDetail(routeId);
    } else {
      this.handleType = "add";
    }
    console.log(routeId);
  },
  methods: {
    getDetail(id) {
      let _this = this;
      api.implement.getDetailById(id).then((res) => {
        _this.formData = res.data;
      });
    },
    handleEdit() {
      api.implement.apiUpdate(this.formData).then((res) => {
        this.$message({
          message: res.message,
          type: "success",
        });
        this.goback();
      });
    },
    handleAdd() {
      api.implement.apiCreate(this.formData).then((res) => {
        this.$message({
          message: res.message,
          type: "success",
        });
        this.goback();
      });
    },
    goback() {
      const { $router } = this;
      $router.push({
        path: "/implementation",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.foot {
  margin: 20px 0;
  text-align: center;
}
</style>
